import React from 'react';
import { useSelector } from 'react-redux';
import type { RouteComponentProps } from 'react-router-dom';

import StarsAccount from '@swf/account';
import type { Modal } from '@swf/core/models/modal';
import { select } from '@swf/core/store';

import ModalRoute from './ModalRoute';

const AccountRoute: React.FC<RouteComponentProps> = ({
  location: { pathname: path },
  staticContext
}) => {
  const embeddedAccount = useSelector(select.location.isEmbeddedAccount);
  const isAuthenticated = useSelector(select.session.isAuthenticated);

  const modal: Modal = { path };

  switch (true) {
    case embeddedAccount && isAuthenticated:
      return <StarsAccount />;
    case !isAuthenticated:
      modal.path = '/auth/login';
      modal.locationState = { path };
      break;
  }

  return <ModalRoute modal={modal} staticContext={staticContext} />;
};

export default AccountRoute;
